// extracted by mini-css-extract-plugin
module.exports = {"powerKitsDownload":"Download_powerKitsDownload__hGTYz"};